import React from 'react';

import { useEventTypes, useLocalStorage, useRouteEventTypes } from '../../hooks';
import { Checkbox, Columns, H2, H3, Modal, Padded, Spacer } from '../atoms';

interface Props {
    toggleSettings: () => void;
}

export const SettingsModal = (props: Props) => {
    const { toggleSettings } = props;
    const eventTypes = useEventTypes();
    const [routeEventTypes, setRouteEventTypes] = useRouteEventTypes();
    const [projectedLocation, setProjectedLocation] = useLocalStorage('useProjectedLocation', false);

    const handleChange = (eventType: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.target;
        const newRouteEventTypes = checked
            ? [...routeEventTypes, eventType]
            : routeEventTypes.filter((type) => type !== eventType);
        setRouteEventTypes(newRouteEventTypes);
    };

    const toggleProjectedLocation = () => {
        setProjectedLocation(!projectedLocation);
    }

    return <Modal isOpen onToggle={toggleSettings} contentLabel='Route overlay settings'>
        <Padded>
            <H2>Map settings</H2>
            <Spacer />
            <H3>Route overlay settings</H3>
            <Spacer half />

            <Columns cols={[1, 1]} gapSize="none" columnGapSize="md">
                {eventTypes
                    .filter((eventType) => !eventType.identifier.includes("_MATCH"))
                    .map((eventType) => <div key={eventType.identifier}>
                        <Checkbox
                            label={eventType.name}
                            id={`${eventType.identifier}_route_settings`}
                            checked={routeEventTypes.includes(eventType.identifier)}
                            onChange={handleChange(eventType.identifier)}
                        />
                    </div>)}
            </Columns>

            <Spacer />

            <H3>Location</H3>
            <Spacer half />

            <Checkbox
                label="Use projected location"
                id="useProjectedLocation"
                checked={projectedLocation}
                onChange={toggleProjectedLocation}
            />
        </Padded>
    </Modal>;
};
